import { HttpClient } from '@angular/common/http';
import { HostListener, Injectable, OnDestroy } from '@angular/core';
import {
  DocumentMediaModel,
  SESSION_STORAGE,
  StorageService,
  User,
} from '@phdsoft/common';
import { OfflineChangesService } from 'projects/phdsoft/common/src/lib/shared/services/offline-changes.service';
import { firstValueFrom } from 'rxjs';
import { AssetManager } from 'src/app/asset-manager/asset-manager';
import { AssetService } from 'src/app/shared/services/asset.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class FileUploadService implements OnDestroy {
  public fileList: File[] = [];

  public constructor(
    private storageService: StorageService,
    private readonly offlineChangesService: OfflineChangesService,
    private assetService: AssetService,
    private assetManager: AssetManager,
    private http: HttpClient
  ) {}

  @HostListener('unloaded')
  public ngOnDestroy(): void {
    console.log('💣 Destroy Upload Service');
  }

  async addDocument(
    fileList: any,
    checkListItemId?: string
  ): Promise<DocumentMediaModel[]> {

    var user = await this.storageService.getItem<User>(
      SESSION_STORAGE.USER,
    )

    const documentsObject: DocumentMediaModel = {
      AssetId: checkListItemId,
      Keywords: `CHECKLISTITEMSAMPLE, INSPECTIONTYPE`,
      DocumentType: 'image',
      CreatedById: user.id
    };

    let  _FORM_DATA = new FormData();
    _FORM_DATA.set('commonMediaViewModel', JSON.stringify(documentsObject));
    for (const file of fileList) {
      _FORM_DATA.append('formFiles', file, file.name);
    }

    let _RESPONSE_MEDIA_LIST: DocumentMediaModel[];

    if (!window.navigator.onLine){
      const url = environment.API_MEDIA + 'Media/PostMediaList'
      this.offlineChangesService.addItem("media", url, "post", _FORM_DATA)
      return _RESPONSE_MEDIA_LIST;
    }

    try {
      documentsObject.BlobPath = null;
      // call api to save data and file
      _RESPONSE_MEDIA_LIST = await firstValueFrom(this.http.post<DocumentMediaModel[]>(
        environment.API_MEDIA + 'Media/PostMediaList',
        _FORM_DATA
      ));

    } catch (error) {
      ///
    }

    return _RESPONSE_MEDIA_LIST;
  }

  async addDocumentSample(
    fileList: File[],
    checkListItemId?: string
  ): Promise<DocumentMediaModel[]> {

    var user = await this.storageService.getItem<User>(
      SESSION_STORAGE.USER,
    )

   // Get Current asset Id
   const _ASSET_ID: string = this.assetService.assetId ?? this.assetManager.asset?.assetInfo.AssetId;

    const documentsObject: DocumentMediaModel = {
      AssetId: _ASSET_ID,
      Keywords: `CHECKLISTITEMSAMPLE, INSPECTIONTYPE`,
      DocumentType: 'image',
      CreatedById: user.id
    };

    let _FORM_DATA = new FormData();
    _FORM_DATA.append('commonMediaViewModel', JSON.stringify(documentsObject));
    for (const file of fileList) {
      _FORM_DATA.append('formFiles', file, file.name);
    }

    let _RESPONSE_MEDIA_LIST: DocumentMediaModel[];

    if (!window.navigator.onLine){
      const url = environment.API_MEDIA + 'Media/PostMediaList'
      this.offlineChangesService.addItem("media", url, "post", _FORM_DATA)
      return _RESPONSE_MEDIA_LIST;
    }

    try {
      documentsObject.BlobPath = null;
      // call api to save data and file
      _RESPONSE_MEDIA_LIST = await firstValueFrom(this.http.post<DocumentMediaModel[]>(
        environment.API_MEDIA + 'Media/PostMediaList',
        _FORM_DATA
      ));

    } catch (error) {
      ///
    }

    return _RESPONSE_MEDIA_LIST;
  }

  async loadImage(mediaId: string){

    let _RESPONSE_MEDIA_LIST: DocumentMediaModel[];

    try {
      _RESPONSE_MEDIA_LIST = await firstValueFrom(this.http.get<DocumentMediaModel[]>(
        environment.API_MEDIA + `Media/GetAssetMediaSecureUrls/${mediaId}` // OBS: this is actually the asset id...
      ));
    } catch (error) {
      ///
    }

    return _RESPONSE_MEDIA_LIST;
  }

  async deleteImage(mediaId: string){
    let _RESPONSE_MEDIA_LIST: any;

    try {
      _RESPONSE_MEDIA_LIST = await firstValueFrom(this.http.delete(
        environment.API_MEDIA + `Media/${mediaId}`
      ));
    } catch (error) {
      ///
      console.log(error)
    }

    return _RESPONSE_MEDIA_LIST;
  }
}
